// Module
var code = "<uib-accordion close-others=\"{{$ctrl.closeOther}}\"> <div ng-transclude></div> </uib-accordion> ";
// Exports
module.exports = code;